module.exports = __webpack_public_path__ + "static/media/activity-dots-circle.d836b388.svg";